
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeClassiEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiEsperienzeClassiRow> {
        protected getFormKey() { return ProdottiEsperienzeClassiForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeClassiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeClassiRow.localTextPrefix; }

        protected form = new ProdottiEsperienzeClassiForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            Q.notifyInfo("OK");
        }
    }
}